export default function itemIdValue({ value }) {
    return value;
}
